import React from 'react';
import { RefreshCw, Loader2 } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export function FeedHeader({ filterType, onFilterChange, refreshing, onRefresh, userName }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-8 pt-4 lg:pt-0">
      <div>
        <h2 data-testid="feed-heading" className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight uppercase">
          Your Feed
        </h2>
        <p className="text-base text-zinc-600 font-medium mt-1">
          {userName ? `Hey ${userName},` : ''} here's what's new
        </p>
      </div>
      <div className="flex items-center gap-3">
        <Select value={filterType} onValueChange={onFilterChange}>
          <SelectTrigger data-testid="filter-type-select" className="w-36 border-2 border-black rounded-none h-10 font-bold text-xs uppercase">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="border-2 border-black rounded-none">
            <SelectItem value="all" data-testid="filter-all">All Types</SelectItem>
            <SelectItem value="substack" data-testid="filter-substack">Substack</SelectItem>
            <SelectItem value="twitter" data-testid="filter-twitter">Twitter</SelectItem>
            <SelectItem value="blog" data-testid="filter-blog">Blog</SelectItem>
            <SelectItem value="podcast" data-testid="filter-podcast">Podcast</SelectItem>
          </SelectContent>
        </Select>
        <button
          data-testid="refresh-feeds-button"
          onClick={onRefresh}
          disabled={refreshing}
          className="brutalist-btn-secondary text-xs flex items-center gap-2 px-4 py-2 disabled:opacity-60"
        >
          {refreshing ? (
            <Loader2 strokeWidth={2.5} size={14} className="animate-spin" />
          ) : (
            <RefreshCw strokeWidth={2.5} size={14} />
          )}
          {refreshing ? 'Refreshing...' : 'Refresh'}
        </button>
      </div>
    </div>
  );
}
